// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#openChatBtn {
    position: fixed;
    right: 20px;
    bottom: 20px;
    background: transparent;
    border: none;
    z-index: 9999;
    cursor: pointer;
}

#openChatBtn img {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

#chatPopup {
    position: fixed;
    bottom: 91px;
    right: 38px;
    width: 400px;
    max-height: 500px;
    background: white;
    border: 1px solid #ccc;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
    z-index: 9999;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    height:80%
}

.chat-header {
    background: #0077cc;
    color: white;
    padding: 10px;
    font-weight: bold;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.chat-content {
    flex: 1 1;
    overflow-y: auto;
    padding: 10px;
}

.chat-input {
    display: flex;
    border-top: 1px solid #eee;
    padding: 10px;
}

.chat-input input {
    flex: 1 1;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.chat-input button {
    margin-left: 10px;
    background: #0077cc;
    color: white;
    border: none;
    padding: 0 12px;
    border-radius: 4px;
    cursor: pointer;
}

.chat-section {
    margin-top: 15px;
}

.chat-section-title {
    font-weight: bold;
    margin-bottom: 5px;
}

.chat-option {
    background: #f3f3f3;
    padding: 6px 10px;
    margin-bottom: 5px;
    border-radius: 4px;
    cursor: pointer;
}

.beta-badge {
    background: orange;
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 0.7em;
    margin-left: 5px;
    color: white;
}

.close {
    cursor: pointer;
    font-size: 20px;
}
.chat-bubble {
    padding: 10px 14px;
    border-radius: 16px;
    margin-bottom: 10px;
    max-width: 80%;
    line-height: 1.4;
    word-wrap: break-word;
}

.user-msg {
    background: #f1f1f1;
    align-self: flex-end;
    text-align: right;
    margin-left: auto;
}

.bot-msg {
    background: #ffffff;
    align-self: flex-start;
    border: 1px solid #e0e0e0;
    text-align: left;
    margin-right: auto;
}

.chat-icons {
    display: flex;
    gap: 10px;
    font-size: 14px;
    margin-top: 5px;
    color: #777;
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/ChatWidget.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uCAAuC;AAC3C;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;IACtB,2CAA2C;IAC3C,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,4BAA4B;IAC5B,6BAA6B;IAC7B,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,aAAa;AACjB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,eAAe;IACf,WAAW;IACX,eAAe;AACnB","sourcesContent":["#openChatBtn {\r\n    position: fixed;\r\n    right: 20px;\r\n    bottom: 20px;\r\n    background: transparent;\r\n    border: none;\r\n    z-index: 9999;\r\n    cursor: pointer;\r\n}\r\n\r\n#openChatBtn img {\r\n    width: 45px;\r\n    height: 45px;\r\n    border-radius: 50%;\r\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n#chatPopup {\r\n    position: fixed;\r\n    bottom: 91px;\r\n    right: 38px;\r\n    width: 400px;\r\n    max-height: 500px;\r\n    background: white;\r\n    border: 1px solid #ccc;\r\n    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);\r\n    z-index: 9999;\r\n    border-radius: 10px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow: hidden;\r\n    height:80%\r\n}\r\n\r\n.chat-header {\r\n    background: #0077cc;\r\n    color: white;\r\n    padding: 10px;\r\n    font-weight: bold;\r\n    border-top-left-radius: 10px;\r\n    border-top-right-radius: 10px;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n\r\n.chat-content {\r\n    flex: 1;\r\n    overflow-y: auto;\r\n    padding: 10px;\r\n}\r\n\r\n.chat-input {\r\n    display: flex;\r\n    border-top: 1px solid #eee;\r\n    padding: 10px;\r\n}\r\n\r\n.chat-input input {\r\n    flex: 1;\r\n    padding: 8px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n}\r\n\r\n.chat-input button {\r\n    margin-left: 10px;\r\n    background: #0077cc;\r\n    color: white;\r\n    border: none;\r\n    padding: 0 12px;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n}\r\n\r\n.chat-section {\r\n    margin-top: 15px;\r\n}\r\n\r\n.chat-section-title {\r\n    font-weight: bold;\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.chat-option {\r\n    background: #f3f3f3;\r\n    padding: 6px 10px;\r\n    margin-bottom: 5px;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n}\r\n\r\n.beta-badge {\r\n    background: orange;\r\n    padding: 2px 6px;\r\n    border-radius: 4px;\r\n    font-size: 0.7em;\r\n    margin-left: 5px;\r\n    color: white;\r\n}\r\n\r\n.close {\r\n    cursor: pointer;\r\n    font-size: 20px;\r\n}\r\n.chat-bubble {\r\n    padding: 10px 14px;\r\n    border-radius: 16px;\r\n    margin-bottom: 10px;\r\n    max-width: 80%;\r\n    line-height: 1.4;\r\n    word-wrap: break-word;\r\n}\r\n\r\n.user-msg {\r\n    background: #f1f1f1;\r\n    align-self: flex-end;\r\n    text-align: right;\r\n    margin-left: auto;\r\n}\r\n\r\n.bot-msg {\r\n    background: #ffffff;\r\n    align-self: flex-start;\r\n    border: 1px solid #e0e0e0;\r\n    text-align: left;\r\n    margin-right: auto;\r\n}\r\n\r\n.chat-icons {\r\n    display: flex;\r\n    gap: 10px;\r\n    font-size: 14px;\r\n    margin-top: 5px;\r\n    color: #777;\r\n    cursor: pointer;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
